import React from 'react';
import PropTypes from 'prop-types';
import manager from '@src/js/TranslationManager';

export default class Translation extends React.Component {

    static get propTypes() {

        return {
            tag: PropTypes.string,
            htmlTag: PropTypes.string,
            className: PropTypes.string,
        };
    }

    render() {

        // eslint-disable-next-line no-unused-vars
        const CustomTag = this.htmlTag ?? 'span';

        return <CustomTag className={ this.props.className }>
            { this.state?.translation ?? ' ' }
        </CustomTag>;
    }

    componentDidMount() {

        this.getTranslation()
            .then((translation) => this.setState({ translation }));
    }

    getTranslation() {

        return manager.get(this.props.tag);
    }

}